import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown, PhoneCall } from "lucide-react";
import LeadForm from "@/components/LeadForm";

export default function CallbackDock() {
  const [minimized, setMinimized] = useState(true);

  return (
    <div className="fixed bottom-4 left-4 z-[60] sm:bottom-6 sm:left-6" data-testid="callback-dock">
      <AnimatePresence mode="wait">
        {minimized ? (
          <motion.button
            key="pill"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 16 }}
            onClick={() => setMinimized(false)}
            className="flex items-center gap-2.5 rounded-full bg-navy px-5 py-3.5 text-sm font-bold text-white shadow-[0_20px_44px_-14px_rgba(10,25,47,0.6)] transition hover:-translate-y-0.5"
            data-testid="callback-dock-open-btn"
          >
            <PhoneCall className="h-4 w-4 text-gold" />
            Request a Callback
          </motion.button>
        ) : (
          <motion.div
            key="card"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 24 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="w-[calc(100vw-2rem)] max-w-[340px] rounded-3xl border border-slate-200 bg-white p-5 shadow-[0_32px_64px_-16px_rgba(10,25,47,0.35)]"
            data-testid="callback-dock-card"
          >
            <div className="mb-4 flex items-start justify-between gap-3">
              <div>
                <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-amber-600">Sticky Desk</p>
                <p className="mt-1 font-display text-lg font-extrabold text-navy">Request a Callback</p>
              </div>
              <button
                onClick={() => setMinimized(true)}
                className="rounded-full border border-slate-200 p-1.5 text-slate-500 transition hover:text-navy"
                aria-label="Minimize callback form"
                data-testid="callback-dock-minimize-btn"
              >
                <ChevronDown className="h-4 w-4" />
              </button>
            </div>
            <LeadForm
              source="home-callback-dock"
              fields={["name", "phone", "service"]}
              cta="Call Me Back"
              idPrefix="callback-dock"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
